/**
 * Локальная генерация MIL-STD-2525 / APP-6 SVG через milsymbol (без внешних API).
 */
import ms from "milsymbol";

const cache = new Map<string, string>();

export function milSidcToDataUrl(sidc: string, size = 35): string {
  const key = `${sidc}|${size}`;
  const hit = cache.get(key);
  if (hit) return hit;
  try {
    const svg = new ms.Symbol(sidc, { size }).asSVG();
    const url = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
    cache.set(key, url);
    return url;
  } catch {
    return "/tactical-pin.svg";
  }
}
